export default "__VITE_ASSET__FP_vgQI___"